module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "for"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#for"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("The earliest Christian writings were letters written to churches. These writings began to appear nearly twenty years after the death and resurrection of Jesus. It may have been as long as another twenty years before written accounts, gospels, began to appear. Thus, there could well have been a forty-year gap between the ministry of Jesus and the earliest extant records.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Of course, there may have been other Christian writings that are now lost. The forty-year gap was a period when the accounts of what Jesus said and did were transmitted by means of oral tradition. Scholars know very little about the exact content of the oral tradition, to which we lack direct access. It may well have varied in extent and exact wording from region to region. There is every reason to believe that early Christian literature preserves the oral tradition of those early decades.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The question immediately arises concerning the reliability of the early oral tradition. To modern ears, four "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("decades of oral transmission sounds like the ideal way to guarantee the "), _c('i', [_vm._v("unreliability")]), _vm._v(" of the tradition.")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("A few decades ago some scholars came together as the Jesus Seminar, a group with a focus on identifying the actual words and deeds of Jesus. Their conclusions confirm the popular belief that “transmitters of oral tradition do not ordinarily remember the exact wording of the saying or parable they are attempting to quote.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")]), _vm._v(" The Seminar proceeds to give a “scientific” explanation: “Recent experiments with memory have led psychologists and others to conclude that the human memory consists of short-term and long-term memory. Short-term memory can retain only about seven items at a time. . . . One experiment has shown that most people forget the exact wording of a particular statement after only sixteen syllables intervene between the original statement and the request to recall that wording.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2",
      "id": "fn2"
    }
  }, [_vm._v("2")])]), _vm._v(" The members of the Jesus Seminar are apparently oblivious to cultural realities of the first century to which, for example, Birger Gerhardsson, among others, has called attention. They blithely assume that modern studies of memory are applicable without modification to the first century. They furthermore confidently assert that the evangelists “supplied dialogue for him [Jesus] on many narrative occasions for which their memories could not recall an appropriate aphorism or parable. In a word, they creatively invented speech for Jesus.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn3",
      "id": "fn3"
    }
  }, [_vm._v("3")])]), _vm._v(" However, this "), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("opinion can hardly be more than pure speculation. In fact, it contradicts what is known about the first-century cultural setting. In short, in contrast to any “controlled” oral tradition, the Seminar views the oral tradition as “uncontrolled.”")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("As David Wenham notes in the present book, recent decades have shown a resurgence of interest in oral tradition in the early church. James D. G. Dunn calls for moving away from the default setting where exclusive attention has been devoted to written sources of the gospels. His work has recently focused on the oral tradition underlying the gospels."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn4",
      "id": "fn4"
    }
  }, [_vm._v("4")]), _vm._v(" Many scholars debate the most appropriate cultural model for describing the process of oral transmission behind the written gospels. Werner H. Kelber argues from a socio-anthropological viewpoint for the repeated, variable oral performances of folklore in ancient cultures."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn5",
      "id": "fn5"
    }
  }, [_vm._v("5")])]), _vm._v(" Kenneth E. Bailey, who worked for many years as a missionary in the Middle East,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn6",
      "id": "fn6"
    }
  }, [_vm._v("6")])]), _vm._v(" proposes an alternative model. There among villagers he observed the oral transmission of various kinds of material with shifting degrees of flexibility (depending on the importance of the material to the identity of the community), handed on under the control of the community. Bailey characterizes "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("such tradition as “informal and controlled”—“informal” because there is no particular teacher or students in view. Anyone in the community can speak or “perform” the material in a particular setting. Remarkably, both N. T. Wright and Dunn opt for Bailey’s model of oral transmission."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn7",
      "id": "fn7"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Despite the use of Bailey’s model, an important question persists: where can we find the most satisfactory explanation of the transmission of oral material "), _c('i', [_vm._v("in first-century Jewish Palestine")]), _vm._v("? Would it not be most natural to look at the transmission of rabbinic material by memorization (a controlled and formal tradition) in Israel at the time of Jesus, as Gerhardsson has done?"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn8",
      "id": "fn8"
    }
  }, [_vm._v("8")])]), _vm._v(" Why go further afield to other countries, other cultures, or to the folklorists and the general phenomena of oral transmission? We may, of course, find some help here to understand the process of oral tradition behind Matthew, Mark, Luke, and John. However, doing so would mislead us as much as help us. It seems safer to stay close to the time and context of the gospels.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("To be sure, Bailey’s work is valuable in many respects. Yet, is it clear that the practice of telling community stories in Arab villages in twentieth-century Lebanon, Syria, or Iraq is a safe guide to what was going on in first-century Jewish Palestine? Where in the New Testament "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("or elsewhere in contemporary literature can one find any examples of, or references to, the community’s communication of stories, the basis of Bailey’s view?")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The choice of this model of oral tradition over Gerhardsson’s model is to my mind a mistake, and methodologically unjustified. It is related to two further oversights, to which we now turn.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("A look at typical rabbinic practice in first-century Jewish contexts—such as Gerhardsson provides"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn9",
      "id": "fn9"
    }
  }, [_vm._v("9")]), _vm._v("—offers a stark contrast to the feeble memories of typical Americans. The Jesus Seminar neglects the uniqueness of the material in the gospels. I mean the uniqueness not merely of the "), _c('i', [_vm._v("content")]), _vm._v(" of the transmitted material but the dramatic importance of the whole "), _c('i', [_vm._v("context")]), _vm._v(" in which that material was given—i.e., the announcement of the dawning of the kingdom of God in and through the person of Jesus the Messiah now present among his people. These points deserve more attention than they are usually given.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("First, the utter uniqueness of Jesus is of great significance for understanding the importance of the oral tradition from the beginning. Why is it that the disciples listened so carefully to his words, treasured them, and memorized them? It was because they had never heard authority like this before (e.g., Mark 1:22, 27; Matt 7:29; Luke 4:32) and because they had come to the conclusion "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("that Jesus was the Messiah (Mark 8:27–30 and parallels). They were experiencing the most exciting time imaginable as they participated in the announcement of the good news of the kingdom, indeed saw it dawning in the words and deeds of their master. This was no ordinary teacher—let alone performing bard or storyteller—but a unique teacher with unparalleled authority. His authority was in a different category than that of the scribes, the scholars of the day. While they compared opinions, he spoke with an astonishing “"), _c('i', [_vm._v("I")]), _vm._v(" say to you.”")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("Matthew, Mark, Luke, and John stress that Jesus was a “teacher” (he is very often referred to as "), _c('i', [_vm._v("didaskalos")]), _vm._v(")."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn10",
      "id": "fn10"
    }
  }, [_vm._v("10")]), _vm._v(" We frequently read of Jesus “teaching.” Jesus as unique teacher is the point expressed in Matt 23:8, 10: “But you are not to be called rabbi, for you have one teacher ("), _c('i', [_vm._v("didaskalos")]), _vm._v("), and you are all students. . . . Nor are you to be called instructors, for you have one instructor ("), _c('i', [_vm._v("kathēgētēs")]), _vm._v("), the Messiah.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn11",
      "id": "fn11"
    }
  }, [_vm._v("11")])]), _vm._v(" On the receiving end of the teaching are the “disciples” ("), _c('i', [_vm._v("mathētai")]), _vm._v("), the specific learners who are taught.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("When you have this kind of teacher, the very embodiment of authority, in this kind of situation, the analogy of rabbi and disciples becomes exceptionally appropriate. Does it not suggest that Gerhardsson is correct in looking "), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("here for the model that underlies the later texts? If Gerhardsson is correct, it rules out an uncontrolled and informal process of transmission. “Informal” tradition means any teacher and any listeners, according to Bailey. But here is a very particular teacher and a very particular group of learners, in a strikingly special relationship.")])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("Second, if the foundational source of the tradition is unique, then the teaching he gives—the content of the tradition—automatically takes on a special character and significance. Rainer Riesner draws attention to this point: “A word of Jesus was important not only because it could have been useful but also because it was the word of the messiah approved by God himself.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn12",
      "id": "fn12"
    }
  }, [_vm._v("12")]), _vm._v(" The material is not ordinary. The word “special” is hardly adequate. This is "), _c('i', [_vm._v("a holy tradition")]), _vm._v(". The words of Jesus were of incalculable worth and importance.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As such, it would seem odd that the sayings of Jesus would have been entrusted to an uncontrolled and informal means of transmission. What fits perfectly the material and the master-disciple relationship of Jesus and the twelve is the model of the Pharisaic rabbi and disciples, where memorization was of a high importance.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Perhaps most importantly, the Jesus tradition as it is found in the gospels shows evidence of being designed for memorization. Riesner, who has studied the material thoroughly, concludes as follows: “According to my estimate, about 80 percent of the separate saying units "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("are formulated in some kind of "), _c('i', [_vm._v("parallelismus membrorum")]), _vm._v(". To this one has to add other poetical techniques such as alliteration, assonance, rhythm and rhyme.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn13",
      "id": "fn13"
    }
  }, [_vm._v("13")]), _vm._v(" Does this point in the direction of an uncontrolled and informal transmission process that features endless variable performances? The very form of the material—as well as its content and its source—makes comparison with ordinary oral material and ordinary methods of transmission unhelpful.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The disciples function as “apostolic custodians” of the tradition. This does not look like an informal transmission, where there is not a set teacher or set students. This looks instead very much like a formal tradition—i.e., one where a specific teacher and specific disciples are in a special relationship, in which there are formal teaching and learning. All of this fits Gerhardsson’s model (formal controlled tradition) far better than Bailey’s model (informal controlled tradition).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("We need finally to address the main objection to the proposal set forth by Gerhardsson. What is the perceived problem with the idea that behind Matthew, Mark, Luke, and John there was an oral tradition that is formal and controlled, along the lines of the transmission of the traditions of the Pharisees? The problem is that the reference to memorization seems incompatible with the differences that are encountered in the renderings of the teaching of Jesus in the Synoptic Gospels. If memory is "), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("involved, it might seem that all the versions must agree verbatim. But we often encounter small differences. This is one of the places where Gerhardsson has been most misunderstood. From the beginning, he drew attention to the fact that minor variations are not incompatible with memorization. In fact, memorization does not prohibit variants, differences, adaptations, etc. Gerhardsson wrote "), _c('i', [_vm._v("Memory and Manuscript")]), _vm._v(" in part to correct the notion. There was of course “early work on the Christ-tradition,” but it “seems to have taken place within fairly restricted limits, and thus to have had only limited freedom.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn14",
      "id": "fn14"
    }
  }, [_vm._v("14")]), _vm._v(" Yet, Gerhardsson does not deny the reality of that freedom and its impact upon the canonical gospels. It is furthermore clear that the variation in the transmission of the sayings of Jesus is much less than in the narrative materials. Only seldom in the Jesus tradition does one encounter halakic material; more often it is analogous to haggadic material, which the Pharisaic-rabbinic practice treated rather more freely. Gerhardsson readily admits that “the twelve and the other authoritative teachers . . . were not traditionists only. They worked with the Word. They worked on the Scriptures, and on the Christ-tradition (which was originally oral): they gathered, formulated (narrative tradition), interpreted, adapted, developed, complemented and put together collections for various definite purposes.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn15",
      "id": "fn15"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Memorization, then, guarantees not every detail but the essence of the transmitted material. As Samuel "), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_vm._v("Byrskog justly puts it: “The difference between the Gospels is no argument against the practice of memorization, as is often assumed, but shows that different people could choose to memorize the same thing in different ways and that memorization, while maintaining its distinctive preservative character, was never an entirely passive enterprise isolated from the social environment and activities of the larger group.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn16",
      "id": "fn16"
    }
  }, [_vm._v("16")]), _vm._v(" Once again, to quote Gerhardsson,")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Memorized texts need not be kept unaltered. I see memorization playing a basic role even when the wording is subject to some variation, particularly in the framework of the sayings and other narrative elements. Texts can also be memorized in more than one version. Textual variants are per se no argument against memorization: indeed, the alterations themselves can reveal a considerable retention of the wording."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn17",
      "id": "fn17"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("It is true, as some have pointed out, that the canonical gospels never report that Jesus taught by repetition to facilitate memorization. The authors of these texts can hardly be faulted for failing to point out something that would have been self-evident in that milieu.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Today, scholars tout their portrayal of “the real "), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("Jesus” or the “historical Jesus.” They throw grave doubt on the historical reliability of Matthew, Mark, Luke, and John. In such a climate, the argument of David Wenham’s excellent book becomes very important. The underlying oral tradition provides the solid bedrock on which the canonical gospels depend, and by its very nature substantiates their trustworthiness.")])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "RightSb1"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONALD")]), _vm._v(" A. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGNER")]), _c('br'), _c('i', [_vm._v("George Eldon Ladd Professor Emeritus"), _c('br'), _vm._v("of New Testament"), _c('br'), _vm._v("Fuller Theological Seminary")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "line",
      "src": "images/line1.jpg"
    }
  })])]), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1"
    }
  }, [_vm._v("1")]), _vm._v(". Robert W. Funk and Roy W. Hoover, eds., "), _c('i', [_vm._v("The Five Gospels")]), _vm._v(" (San Francisco: HarperSanFrancisco, 1997), 1.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2"
    }
  }, [_vm._v("2")]), _vm._v(". Funk and Hoover, "), _c('i', [_vm._v("The Five Gospels")]), _vm._v(", 28.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn3"
    }
  }, [_vm._v("3")]), _vm._v(". Funk and Hoover, "), _c('i', [_vm._v("The Five Gospels")]), _vm._v(", 28.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn4"
    }
  }, [_vm._v("4")]), _vm._v(". See James D. G. Dunn, "), _c('i', [_vm._v("Jesus Remembered")]), _vm._v(", vol. 1 of "), _c('i', [_vm._v("Christianity in the Making")]), _vm._v(" (Grand Rapids: Eerdmans, 2003), 173–254.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn5"
    }
  }, [_vm._v("5")]), _vm._v(". Werner H. Kelber, "), _c('i', [_vm._v("The Oral and the Written Gospel")]), _vm._v(" (Philadelphia: Fortress, 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn6"
    }
  }, [_vm._v("6")]), _vm._v(". See Kenneth E. Bailey, “Informal Controlled Oral Tradition and the Synoptic Gospels,” "), _c('i', [_vm._v("Asia Journal of Theology")]), _vm._v(" 5 (1991): 34–54; and Kenneth E. Bailey, “Middle Eastern Oral Tradition and the Synoptic Gospels,” "), _c('i', [_vm._v("ExpT")]), _vm._v(" 106 (1995): 363–67.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn7"
    }
  }, [_vm._v("7")]), _vm._v(". Dunn, "), _c('i', [_vm._v("Jesus Remembered")]), _vm._v(", 205–9; N. T. Wright, "), _c('i', [_vm._v("Jesus and the Victory of God")]), _vm._v(", vol. 2 of "), _c('i', [_vm._v("Christian Origins and the Question of God")]), _vm._v(" (Minneapolis: Fortress, 1996), 133–37.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn8"
    }
  }, [_vm._v("8")]), _vm._v(". Gerhardsson’s initial work, in the 1960s, was meant as a counter to Rudolf Bultmann’s support for an informal and uncontrolled process of oral transmission.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn9"
    }
  }, [_vm._v("9")]), _vm._v(". See Birger Gerhardsson, "), _c('i', [_vm._v("Memory and Manuscript: Oral Tradition and Written Transmission in Rabbinic Judaism and Early Christianity")]), _vm._v(" with "), _c('i', [_vm._v("Tradition and Transmission in Early Christianity")]), _vm._v(" (Grand Rapids: Eerdmans, 1998), and Birger Gerhardsson, "), _c('i', [_vm._v("The Reliability of the Gospel Tradition")]), _vm._v(" (Peabody, MA: Hendrickson, 2001).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn10"
    }
  }, [_vm._v("10")]), _vm._v(". The use of the phrase “canonical gospels”—here and in the text of Wenham below—risks anachronism. It refers to the four texts (Matthew, Mark, Luke, and John) that would become canonical. The canonical gospels are distinguished in this argument (and in the argument of Wenham) from other gospels in early Christian literature.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn11"
    }
  }, [_vm._v("11")]), _vm._v(". See Samuel Byrskog, "), _c('i', [_vm._v("Jesus the Only Teacher: Didactic Authority and Transmission in Ancient Israel, Ancient Judaism and the Matthean Community")]), _vm._v(", Coniectanea Biblica New Testament Series 24 (Stockholm: Almqvist & Wiksell International, 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn12"
    }
  }, [_vm._v("12")]), _vm._v(". Rainer Riesner, “Jesus as Preacher and Teacher,” in "), _c('i', [_vm._v("Jesus and the Oral Gospel Tradition,")]), _vm._v(" ed. Henry Wansbrough, JSNTSup 64 (Sheffield: Sheffield Academic Press, 1991), 209.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn13"
    }
  }, [_vm._v("13")]), _vm._v(". Riesner, “Jesus as Preacher and Teacher,” 202. See Rainer Riesner, "), _c('i', [_vm._v("Jesus als Lehrer: Eine Untersuchung zum Ursprung der Evangelien-Überlieferung")]), _vm._v(", 3rd ed., WUNT 2.7 (Tübingen: Mohr Siebeck, 1988), 392–404.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn14"
    }
  }, [_vm._v("14")]), _vm._v(". Gerhardsson, "), _c('i', [_vm._v("Memory and Manuscript")]), _vm._v(", 44. See note 9 above.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn15"
    }
  }, [_vm._v("15")]), _vm._v(". Gerhardsson, "), _c('i', [_vm._v("Memory and Manuscript")]), _vm._v(", 40.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn16"
    }
  }, [_vm._v("16")]), _vm._v(". Samuel Byrskog, “The Transmission of the Jesus Tradition,” in "), _c('i', [_vm._v("Handbook for the Study of the Historical Jesus")]), _vm._v(", ed. Tom Holmén and Stanley E. Porter (Leiden: Brill, 2011), 2:1465–94 (esp. 1487).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn17"
    }
  }, [_vm._v("17")]), _vm._v(". Birger Gerhardsson, “The Secret of the Transmission of the Unwritten Jesus Tradition,” "), _c('i', [_vm._v("NTS")]), _vm._v(" 51 (2005): 1–18 (here 16).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f05f049","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/foreword.vue
// module id = 66
// module chunks = 0